
import css from 'styled-jsx/css';

export default css.global`/* @styled-jsx=global */

.webinar-details__wrapper {
  grid-column: content;
  padding: 60px 0;
}

.webinar-details {
  display: grid;
  grid-template-columns: [sidebar] 4fr [main] 8fr;
  grid-template-rows: auto auto 1fr;
  grid-gap: 40px;
  margin: 0 auto;
  max-width: $container-max-width;
  width: 100%;

  &__main,
  &__speakers,
  &__datetime,
  &__resources {
    grid-column: sidebar / span 2;
    p {
      line-height: 1.4;
      font-size: 16px;
    }
  }

  &__speakers {
    > * + * {
      margin-top: 1.5em;
    }
  }
  &__speaker {
    display: flex;

    &--avatar {
      max-width: 60px;
      padding-right: 1em;

      img {
        border-radius: 100%;
      }
    }
  }

  &__resources {
    display: none;
  }

  &__resource {
    @include focusable;
    display: block;
    padding: 6px 0;
    color: $slate;
    text-decoration: none;
    position: relative;
    outline: none;
  }

  &__resources-title,
  &__datetime-title {
    margin-bottom: 5px;
  }

  &__main {
    h2 {
      span {
        font-weight: normal;
      }
    }

    > * + * {
      margin-top: 2em;
    }

    .rich-text {
      p,
      .rich-text p {
        font-size: 16px;
        line-height: 1.4;
      }

      ul {
        padding-left: 15px;
        margin: 15px 0;
      }

      ul li {
        list-style-type: disc;
        background: none;
        padding-left: 5px;
        margin-bottom: 0.5em;

        p {
          padding-left: 0;
          &::before {
            background: none;
          }
        }

        &::before {
          background: none;
        }
      }

      h2,
      h3,
      h4,
      h5 {
        font-weight: 700;
        font-size: 16px;
      }
    }

    &--description .rich-text {
      > * + * {
        margin-top: 2em;
      }
      h3 {
        font-weight: bold;
        line-height: 1.2;
      }
    }
  }

  &__datetime-timestamp {
    padding-top: 6px;
  }
}

@include media-query(tablet) {
  .webinar-details {
    margin-top: 30px;
  }

  .webinar-details__speakers,
  .webinar-details__datetime,
  .webinar-details__resources {
    grid-column: sidebar;
  }
  .webinar-details__datetime {
    grid-row: 2;
  }
  .webinar-details__resources {
    grid-row: 3;
    display: block;
  }
  .webinar-details__main {
    grid-column: main;
    grid-row: span 3;

    h2,
    h3,
    h4,
    h5 {
      font-weight: 400;
      font-size: 26px;
    }
  }
}
`